import { Button, Form, Input, Select } from "antd";
import { useHotelRules } from "./modules/useHotelRules";
const { Option } = Select;

const HotelRulesScreen = () => {
  const { rulesData, isCreating, handleInputChange, handleSaveRules } =
    useHotelRules();
  return (
    <div className="container">
      <h1>Manage Hotel Rules</h1>
      <Form layout="vertical">
        <Form.Item label="Check-In Time From">
          <Input
            type="time"
            value={rulesData.checkInTimeFrom}
            onChange={(e) =>
              handleInputChange("checkInTimeFrom", e.target.value)
            }
          />
        </Form.Item>

        <Form.Item label="Check-Out Time Before">
          <Input
            type="time"
            value={rulesData.checkOutTimeBefore}
            onChange={(e) =>
              handleInputChange("checkOutTimeBefore", e.target.value)
            }
          />
        </Form.Item>

        <Form.Item label="Early Check-In Charge">
          <Input
            type="number"
            value={rulesData.earlyCheckInCharge}
            onChange={(e) =>
              handleInputChange("earlyCheckInCharge", e.target.value)
            }
          />
        </Form.Item>

        <Form.Item label="Late Check-Out Charge">
          <Input
            type="number"
            value={rulesData.lateCheckOutCharge}
            onChange={(e) =>
              handleInputChange("lateCheckOutCharge", e.target.value)
            }
          />
        </Form.Item>

        <Form.Item label="Smoking Rule">
          <Input
            value={rulesData.smokingRule}
            onChange={(e) => handleInputChange("smokingRule", e.target.value)}
          />
        </Form.Item>

        <Form.Item label="Pet Allowed">
          <Select
            value={rulesData.petAllow}
            onChange={(value) => handleInputChange("petAllow", value)}
          >
            <Option value={true}>Yes</Option>
            <Option value={false}>No</Option>
          </Select>
        </Form.Item>

        <Form.Item label="Damage Compensation">
          <Input
            value={rulesData.damageCompensation}
            onChange={(e) =>
              handleInputChange("damageCompensation", e.target.value)
            }
          />
        </Form.Item>

        <Form.Item label="House Keeping Policy">
          <Input
            value={rulesData.houseKeepingPolicy}
            onChange={(e) =>
              handleInputChange("houseKeepingPolicy", e.target.value)
            }
          />
        </Form.Item>

        <Form.Item label="No Show Charge (%)">
          <Input
            type="number"
            value={rulesData.noShowCharge}
            onChange={(e) => handleInputChange("noShowCharge", e.target.value)}
          />
        </Form.Item>

        <Form.Item label="Lost and Found Policy">
          <Input
            value={rulesData.lostAndFoundPolicy}
            onChange={(e) =>
              handleInputChange("lostAndFoundPolicy", e.target.value)
            }
          />
        </Form.Item>

        <Form.Item label="Refund Policy">
          <Input
            value={rulesData.refundPolicy}
            onChange={(e) => handleInputChange("refundPolicy", e.target.value)}
          />
        </Form.Item>

        <Form.Item label="Force Majeure Event">
          <Input
            value={rulesData.forceMajeureEvent}
            onChange={(e) =>
              handleInputChange("forceMajeureEvent", e.target.value)
            }
          />
        </Form.Item>

        <Form.Item label="Hotel Rule">
          <Input
            value={rulesData.hotelRule}
            onChange={(e) => handleInputChange("hotelRule", e.target.value)}
          />
        </Form.Item>

        <Button type="primary" onClick={handleSaveRules}>
          {isCreating ? "Create Rules" : "Save Changes"}
        </Button>
      </Form>
    </div>
  );
};

export default HotelRulesScreen;
